import React from 'react';
import { ArrowRight, Play } from 'lucide-react';

const WaitlistHero = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="relative overflow-hidden bg-black">
      {/* Background layers */}
      <div className="absolute inset-0 hero-neon-bg pointer-events-none" />
      <div className="absolute inset-0 grid-lines pointer-events-none opacity-50" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-24 md:pt-32 pb-28 md:pb-40 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/[0.04] border border-white/10 fade-up">
          <span className="h-1.5 w-1.5 rounded-full bg-[#39D353] neon-dot" />
          <span className="text-[12px] text-neutral-200 font-medium tracking-wide">
            Private waitlist open · Launching Q4 2026
          </span>
        </div>

        {/* Headline */}
        <h1 className="mt-8 text-[clamp(2.75rem,7.5vw,6rem)] leading-[0.98] font-bold tracking-tight fade-up">
          <span className="block text-white">Finally, somewhere</span>
          <span className="block text-white">to spend your <span className="neon-text italic">crypto</span>.</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-7 max-w-2xl mx-auto text-neutral-400 text-base md:text-lg leading-relaxed fade-up-2">
          ChainKart is the luxury Web3 marketplace where you shop premium brands, watch live drops,
          and bid in high-stakes auctions — paid entirely with your favorite crypto.
        </p>

        {/* CTAs */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 fade-up-3">
          <button
            onClick={() => scrollTo('waitlist')}
            className="btn-neon inline-flex items-center gap-2 h-14 px-8 rounded-full text-[15px] font-semibold"
          >
            Join the Waitlist
            <ArrowRight size={17} />
          </button>
          <button
            onClick={() => scrollTo('how-it-works')}
            className="btn-dark inline-flex items-center gap-2 h-14 px-8 rounded-full text-[15px] font-semibold"
          >
            <Play size={14} className="fill-white" />
            How It Works
          </button>
        </div>

        {/* Trust row */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[11px] tracking-[0.15em] text-neutral-500 uppercase fade-up-3">
          <span>Accepted: BTC · ETH · SOL · USDC · BNB</span>
          <span className="h-1 w-1 rounded-full bg-neutral-700" />
          <span>Non-custodial checkout</span>
          <span className="h-1 w-1 rounded-full bg-neutral-700" />
          <span>Fully verified merchants</span>
        </div>
      </div>
    </section>
  );
};

export default WaitlistHero;
